module.exports = {
  base_url : process.env.base_url || "http://localhost:3020/",
  //api_base_url : process.env.api_base_url || "https://coldstar.dbtez.in/api/",
  //fapi_base_url : process.env.api_base_url || "https://coldstar.dbtez.in/api2/",
  //api_base_url : process.env.api_base_url || "https://dev2cstar.memdb.in/api/",
  //api_base_url : process.env.api_base_url || "https://app.dev.cstr.dbtez.net/api/",
  api_base_url : process.env.api_base_url || "https://coldstar.dbtez.com/api/",
  fapi_base_url : process.env.api_base_url || "https://coldstar.dbtez.com/api2/",
};
